import { useRouter } from 'next/router'
import shallow from 'zustand/shallow'
import { useAuthStore } from '../dataStores/auth'

export const REPAIRED_VIEWER_MARKER = 'view_repaired_failures_only'

type ReturnProps = {
  belongsTo: (communeSlug: string | string[]) => boolean
  hasPermission: (permission: string, communeSlug?: string | null) => boolean
  isRestrictedViewer: (communeSlug?: string | null) => boolean
}

const usePermissions = (): ReturnProps => {
  const { query } = useRouter()
  const [user, communes] = useAuthStore((state) => [state.user, state.communes], shallow)

  const belongsTo = (communeSlug: string | string[]) => {
    const slug = Array.isArray(communeSlug) ? communeSlug[0] : communeSlug
    return !!communes?.find((commune) => commune.slug === slug)
  }

  const hasPermission = (permission: string, communeSlug?: string | null) => {
    if (user?.is_superuser) {
      return true
    }

    const slug = communeSlug ?? query.communeSlug

    const userPermissions =
      user?.memberships
        .filter((membership) => membership.commune.slug === slug)
        .reduce<string[]>((acc, current) => [...acc, ...current.role.permissions], []) || []

    return userPermissions.includes(permission)
  }

  const isRestrictedViewer = (communeSlug?: string | null) => {
    if (user?.is_superuser) {
      return false
    }

    return hasPermission(REPAIRED_VIEWER_MARKER, communeSlug)
  }

  return {
    belongsTo,
    hasPermission,
    isRestrictedViewer,
  }
}

export default usePermissions
